import React from "react";
import "./CreditReportAuthorization.css";

const CreditReportAuthorizationPrompt = ({
  checked,
  onChange,
  disabled = false,
  inputId = "credit-report-authorized",
  titleId = `${inputId}-title`,
}) => (
  <section
    className="credit-report-prompt"
    aria-labelledby={titleId}
  >
    <h2 id={titleId}>
      Authorization to Obtain and Review My Credit Report After Bankruptcy
    </h2>

    <div className="credit-report-prompt__copy">
      <p>
        As part of Evergreen Financial Counseling&apos;s post-bankruptcy credit
        education services, Evergreen will review my credit report to see if any
        errors are listed after my bankruptcy.
      </p>
      <p>
        By checking the box below, I authorize Evergreen Financial Counseling,
        Inc. (&quot;Evergreen&quot;), and authorized service providers acting on
        Evergreen&apos;s behalf, to obtain and review my consumer credit report for
        errors following the discharge of my bankruptcy.
      </p>
      <p>
        I understand that Evergreen is not a credit repair organization, law
        firm, or credit reporting agency and cannot guarantee that any
        information on my credit report will be changed, corrected, or removed.
      </p>
    </div>

    <label className="credit-report-prompt__checkbox" htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
      />
      <span>
        Yes, authorize Evergreen Financial Counseling to obtain and review my
        consumer credit report for the purposes described above.
      </span>
    </label>

    <p className="credit-report-prompt__electronic">
      My electronic consent has the same effect as my written authorization.
      Authorization is optional, and I may continue without checking the box.
    </p>
  </section>
);

export default CreditReportAuthorizationPrompt;
